import * as actionType from '../constants/actionTypes'

const initialState = {
  loaded: false,
  list: [],
  filter: {
    search: null,
    languageId: null,
    tags: [],
  },
}

export default (state = initialState, action) => {

  switch (action.type) {
    case actionType.QUESTIONS_DATA_LOAD:
      return {
        ...state,
        loaded: true,
        list: action.questions,
      }

    case actionType.QUESTIONS_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.filter,
        },
      }

    case actionType.QUESTIONS_REMOVE:
      const newQuestions = state.list.filter(q => q.id !== action.id)

      return {
        ...state,
        list: newQuestions
      }

    case actionType.QUESTIONS_DATA_REFRESH:
      return {
        ...state,
        list: action.questions,
      }

    default:
      return state
  }
}
